/**
 * @module store/slides/actions
 *
 * @version 1.0.2
 * @copyright SBC 2019
 */


import { Auth } from 'aws-amplify';


import { apiGetSlides, apiUpdateSlides } from '@/api';
import * as types from '@/store/mutation-types';

/**
 * Action: Получение слайдов
 *
 * @since Version 1.0.0
 */
const getSlides = async ({ commit, rootGetters }) => {
  commit(types.GET_SLIDES_ASYNC.PENDING);
  try {
    if (rootGetters['user/isLoggin']) {
      const user = rootGetters['user/user'];
      const userSession = await Auth.userSession(user);

      const { data } = await apiGetSlides(userSession.accessToken.jwtToken);

      commit(types.GET_SLIDES_ASYNC.SUCCESS, data.slides);
    } else {
      throw new Error('Неавторизованный пользователь не может получить список слайдов.');
    }
  } catch (error) {
    console.log(error);
    commit(types.GET_SLIDES_ASYNC.FAILURE);
  }
};

const updateSlides = async ({ commit, dispatch, rootGetters }, slides) => {
  commit(types.GET_SLIDES_ASYNC.PENDING);
  try {
    if (rootGetters['user/isLoggin']) {
      const user = rootGetters['user/user'];
      const userSession = await Auth.userSession(user);

      await apiUpdateSlides(userSession.accessToken.jwtToken, slides);

      dispatch('getSlides');
    } else {
      throw new Error('Неавторизованный пользователь не может получить список слайдов.');
    }
  } catch (error) {
    console.log(error);
    commit(types.GET_SLIDES_ASYNC.FAILURE);
  }
};

export default {
  getSlides,
  updateSlides,
};
